/* Sanshi Playroom — theme.js
   Replaces the React state in the original app/page.tsx with vanilla DOM work.
   The class names it toggles are exactly the ones the ported CSS expects:
     menuOpen   -> .main-nav.is-open
     searchOpen -> .search-bar[hidden]
     cartOpen   -> #cart-drawer-root[hidden]
     liked[]    -> .heart-button.liked (localStorage)
   No dependencies, no build step. */
(function () {
  'use strict';

  var routes = window.LG_ROUTES || {};
  var strings = window.LG_STRINGS || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function on(el, type, fn) { if (el) el.addEventListener(type, fn); }

  /* ------------------------------------------------------------------ menu */
  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('.main-nav');
    if (!toggle || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? (strings.closeMenu || 'Close menu') : (strings.openMenu || 'Open menu'));
      $$('[data-icon-menu], [data-icon-close]', toggle).forEach(function (icon) {
        icon.hidden = icon.hasAttribute('data-icon-menu') ? open : !open;
      });
    }

    on(toggle, 'click', function () { setOpen(!nav.classList.contains('is-open')); });
    // Mirrors the React handler: every nav link closed the menu on click.
    $$('a', nav).forEach(function (a) { on(a, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* -------------------------------------------------------------- submenus */
  function initSubmenus() {
    var items = $$('.nav-item.has-children');
    if (!items.length) return;

    function setExpanded(item, expanded) {
      var button = $('.nav-toggle', item);
      item.classList.toggle('is-expanded', expanded);
      if (!button) return;
      button.setAttribute('aria-expanded', String(expanded));
      var label = button.getAttribute(expanded ? 'data-label-collapse' : 'data-label-expand');
      if (label) button.setAttribute('aria-label', label);
    }
    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) setExpanded(item, false); });
    }

    items.forEach(function (item) {
      var button = $('.nav-toggle', item);
      on(button, 'click', function () {
        var open = !item.classList.contains('is-expanded');
        closeAll(item);
        setExpanded(item, open);
      });
      on(item, 'focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setExpanded(item, false);
      });
    });
    on(document, 'click', function (e) {
      if (!e.target.closest('.nav-item.has-children')) closeAll(null);
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  /* ---------------------------------------------------------------- search */
  function initSearch() {
    var toggle = $('[data-search-toggle]');
    var bar = $('.search-bar');
    if (!toggle || !bar) return;
    var input = $('input[name="q"]', bar);
    var panel = $('[data-predictive]', bar);
    var timer = null;
    var lastQuery = '';

    function setOpen(open) {
      bar.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open && input) input.focus();
      if (!open && panel) { panel.hidden = true; panel.innerHTML = ''; }
    }

    on(toggle, 'click', function () { setOpen(bar.hidden); });
    on($('[data-search-close]', bar), 'click', function () { setOpen(false); toggle.focus(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && !bar.hidden) { setOpen(false); } });

    if (!input || !panel || !routes.predictiveSearchUrl) return;

    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { panel.hidden = true; panel.innerHTML = ''; lastQuery = ''; return; }
      if (q === lastQuery) return;
      timer = setTimeout(function () {
        lastQuery = q;
        var url = routes.predictiveSearchUrl + '?q=' + encodeURIComponent(q) +
                  '&resources[type]=product&resources[limit]=4&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var result = parsed.querySelector('[data-predictive-inner]');
            panel.innerHTML = result ? result.innerHTML : '';
            panel.hidden = !result;
          })
          .catch(function () { panel.hidden = true; });
      }, 220);
    });

    // Clicking outside the header search closes the panel, not the bar.
    on(document, 'click', function (e) {
      if (!bar.contains(e.target) && !toggle.contains(e.target)) { panel.hidden = true; }
    });
  }

  /* ------------------------------------------------------------ cart drawer */
  var Cart = {
    root: function () { return $('#cart-drawer-root'); },

    open: function () {
      var root = this.root();
      if (!root) return;
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      var close = $('[data-drawer-close]', root);
      if (close) close.focus();
    },

    close: function () {
      var root = this.root();
      if (!root) return;
      root.hidden = true;
      document.body.style.overflow = '';
    },

    isOpen: function () { var r = this.root(); return !!r && !r.hidden; },

    busy: function (state) {
      var drawer = $('.cart-drawer');
      if (drawer) drawer.classList.toggle('is-busy', state);
    },

    /* Re-render the drawer, the bag count and (on /cart) the cart page from the
       Section Rendering API payload that ships with every cart mutation. */
    render: function (sections) {
      if (!sections) return;
      var wasOpen = this.isOpen();

      var root = this.root();
      var drawerId = root && root.getAttribute('data-section-id');
      if (root && drawerId && sections[drawerId]) {
        var fresh = new DOMParser().parseFromString(sections[drawerId], 'text/html');
        var next = fresh.querySelector('#cart-drawer-root');
        if (next) { root.innerHTML = next.innerHTML; root.hidden = !wasOpen; }
      }

      var pageHost = $('[data-cart-page]');
      var pageId = pageHost && pageHost.getAttribute('data-section-id');
      if (pageHost && pageId && sections[pageId]) {
        var page = new DOMParser().parseFromString(sections[pageId], 'text/html').querySelector('[data-cart-page]');
        if (page) pageHost.innerHTML = page.innerHTML;
      }
      this.syncCount(sections.count);
    },

    syncCount: function (count) {
      if (typeof count === 'undefined') {
        var badge = $('#cart-drawer-root [data-cart-count-source]');
        count = badge ? badge.getAttribute('data-cart-count-source') : null;
      }
      if (count === null || typeof count === 'undefined') return;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      $$('[data-cart-count-label]').forEach(function (el) {
        el.setAttribute('aria-label', (strings.bagLabel || 'Shopping bag with %%count%% items').replace('%%count%%', count));
      });
    },

    mutate: function (url, body) {
      var self = this;
      /* Section ids must be read from the DOM, not hardcoded: a section coming
         from a JSON template has a dynamic id (template--1234__main), and the
         API keys its response by that id. */
      body.sections = self.sectionIds();
      body.sections_url = window.location.pathname;
      self.busy(true);
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.data && res.data.description ? res.data.description : (strings.cartError || 'Something went wrong.')); }
          return fetch(routes.cartUrl + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var sections = res.data.sections || {};
              sections.count = cart.item_count;
              self.render(sections);
              return cart;
            });
        })
        .finally(function () { self.busy(false); });
    },

    sectionIds: function () {
      var ids = [];
      var root = this.root();
      var pageHost = $('[data-cart-page]');
      if (root && root.getAttribute('data-section-id')) ids.push(root.getAttribute('data-section-id'));
      if (pageHost && pageHost.getAttribute('data-section-id')) ids.push(pageHost.getAttribute('data-section-id'));
      return ids.join(',');
    },

    add: function (items) {
      return this.mutate(routes.cartAddUrl, { items: items });
    },

    change: function (key, quantity) {
      return this.mutate(routes.cartChangeUrl, { id: key, quantity: quantity });
    }
  };

  function initCart() {
    // Open/close. Delegated so re-rendered drawer markup keeps working.
    on(document, 'click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); Cart.open(); return; }

      var closeBtn = e.target.closest('[data-drawer-close]');
      if (closeBtn) { e.preventDefault(); Cart.close(); return; }

      // Backdrop click closes; clicks inside the drawer do not (stopPropagation
      // in the React original).
      var backdrop = e.target.closest('.drawer-backdrop');
      if (backdrop && !e.target.closest('.cart-drawer')) { Cart.close(); return; }

      var remove = e.target.closest('[data-line-remove]');
      if (remove) {
        e.preventDefault();
        Cart.change(remove.getAttribute('data-line-remove'), 0).catch(showError);
        return;
      }

      var step = e.target.closest('[data-qty-step]');
      if (step) {
        e.preventDefault();
        var wrap = step.closest('.qty-selector');
        var field = $('input', wrap);
        if (!field) return;
        var min = parseInt(field.getAttribute('min') || '0', 10);
        var next = Math.max(min, (parseInt(field.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
        field.value = next;
        var key = field.getAttribute('data-line-key');
        if (key) Cart.change(key, next).catch(showError);
      }
    });

    on(document, 'keydown', function (e) { if (e.key === 'Escape' && Cart.isOpen()) Cart.close(); });

    // Quantity typed directly into a cart line.
    on(document, 'change', function (e) {
      var field = e.target.closest('input[data-line-key]');
      if (!field) return;
      var q = Math.max(0, parseInt(field.value, 10) || 0);
      Cart.change(field.getAttribute('data-line-key'), q).catch(showError);
    });

    // Add to cart: the homepage quick-add buttons and the product form.
    on(document, 'submit', function (e) {
      var form = e.target.closest('[data-add-to-cart]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (!id || !id.value) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      Cart.add([{ id: Number(id.value), quantity: Number(qty && qty.value ? qty.value : 1) }])
        .then(function () { Cart.open(); })
        .catch(showError)
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  function showError(err) {
    var msg = (err && err.message) || (strings.cartError || 'Something went wrong.');
    var host = $('[data-cart-error]');
    if (host) { host.textContent = msg; host.hidden = false; setTimeout(function () { host.hidden = true; }, 6000); }
    else { console.error('[cart]', msg); }
  }

  /* -------------------------------------------------------------- wishlist */
  var KEY = 'lumagrain:liked';

  function likedSet() {
    try { return new Set(JSON.parse(localStorage.getItem(KEY) || '[]')); }
    catch (e) { return new Set(); }
  }

  function saveLiked(set) {
    // Array.prototype.slice does not work on a Set — it is not array-like.
    try { localStorage.setItem(KEY, JSON.stringify(Array.from(set))); }
    catch (e) { /* private mode — hearts simply do not persist */ }
  }

  function initWishlist() {
    var liked = likedSet();

    function paint(btn) {
      var id = btn.getAttribute('data-like');
      var isLiked = liked.has(id);
      btn.classList.toggle('liked', isLiked);
      btn.setAttribute('aria-pressed', String(isLiked));
      var title = btn.getAttribute('data-like-title') || '';
      btn.setAttribute('aria-label', (isLiked ? (strings.unlike || 'Remove %%title%% from favorites')
                                              : (strings.like || 'Add %%title%% to favorites')).replace('%%title%%', title));
    }

    $$('[data-like]').forEach(paint);

    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-like]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-like');
      if (liked.has(id)) { liked.delete(id); } else { liked.add(id); }
      saveLiked(liked);
      $$('[data-like="' + id.replace(/"/g, '\\"') + '"]').forEach(paint);
    });
  }

  /* ------------------------------------------------------------ product page */
  function initProduct() {
    var form = $('[data-product-form]');
    if (!form) return;
    var idField = $('[name="id"]', form);
    var submit = $('[type="submit"]', form);
    var priceHost = $('[data-price-host]');
    var variants;
    try { variants = JSON.parse($('[data-variant-data]').textContent); }
    catch (e) { return; }

    var groups = $$('[data-option-index]', form);

    /* A product with only a default variant renders no option groups. Liquid has
       already produced the correct button; matching against an empty selection
       never succeeds and would mark a perfectly buyable product Unavailable. */
    if (!groups.length) return;

    function selected() {
      return groups.map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function update() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.length === chosen.length &&
               v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) {
        if (submit) { submit.disabled = true; submit.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idField) idField.value = match.id;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? (strings.addToBag || 'Add to bag') : (strings.soldOut || 'Sold out');
      }
      if (priceHost && match.price_html) priceHost.innerHTML = match.price_html;
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
      // Jump the gallery to this variant's image.
      if (match.featured_media_id) {
        var thumb = $('[data-media-id="' + match.featured_media_id + '"]');
        if (thumb) thumb.click();
      }
    }

    on(form, 'change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    update();
  }

  function initGallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $$('[data-media-id]').forEach(function (thumb) {
      on(thumb, 'click', function () {
        var src = thumb.getAttribute('data-media-src');
        var srcset = thumb.getAttribute('data-media-srcset');
        var img = $('img', main);
        if (img && src) { img.src = src; if (srcset) img.srcset = srcset; img.alt = thumb.getAttribute('data-media-alt') || ''; }
        $$('[data-media-id]').forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
      });
    });
  }

  /* ----------------------------------------------------------- collection UI */
  function initSort() {
    var select = $('[data-sort]');
    on(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  /* Editorial sections arrive with the page, then rise into place once. The
     readiness class keeps content visible when JavaScript is unavailable, and
     reduced-motion visitors bypass the observer entirely. */
  function initEditorialReveals() {
    var items = $$('[data-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    document.documentElement.classList.add('editorial-reveal-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    items.forEach(function (item) { observer.observe(item); });
  }

  function boot() {
    initMenu();
    initSubmenus();
    initSearch();
    initCart();
    initWishlist();
    initProduct();
    initGallery();
    initSort();
    initEditorialReveals();
    Cart.syncCount();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  // Theme editor re-renders sections in place; rebind afterwards.
  document.addEventListener('shopify:section:load', boot);

  window.SanshiPlayroomCart = Cart;
  window.LumaGrainCart = Cart; // Backwards-compatible alias for older customisations.
})();
